import {MARKERERROR} from './MarkerErrorTypes'

const initialState = {
    markerError : false
}

const MarkerErrorReducer = (state = initialState, action) => {
    
    switch (action.type) {
        case MARKERERROR:
            
            return {
                markerError : action.load
            }
    
        default:
          return state
    }

}

export default MarkerErrorReducer;